import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { formatStockTransferSourceTypeLabel } from '#/modules/imsMgmt/receipts/stockTransfer/helper/transferSourceType';

import { Badge } from './Badge';

/** 寫死色票：深底淺字；未知值走 slate。 */
const SOURCE_TYPE_CLASS = {
  MANUAL: 'border-transparent bg-zinc-600 text-zinc-50',
  WORK_ORDER: 'border-transparent bg-indigo-600 text-indigo-50',
};

const SIZE_CLASS = {
  default: 'h-7 px-2.5 text-sm',
  sm: 'h-7 px-2.5 text-sm',
};

const StockTransferSourceTypeBadge = ({ sourceType, size = 'default', className }) => {
  const label = formatStockTransferSourceTypeLabel(sourceType);
  const toneClass = SOURCE_TYPE_CLASS[sourceType]
    ?? 'border-transparent bg-slate-600 text-slate-50';

  return (
    <Badge
      variant="secondary"
      className={cn(SIZE_CLASS[size] ?? SIZE_CLASS.default, toneClass, className)}
    >
      {label}
    </Badge>
  );
};

StockTransferSourceTypeBadge.propTypes = {
  sourceType: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export { StockTransferSourceTypeBadge };
